export { default as PaymentLectureSummary } from './payment-lecture-summary'
